import ue from "./objectWithoutPropertiesLoose3.mjs";
import S from "./extends3.mjs";
import * as a from "react";
import r from "./index180.mjs";
import { clsx as ce } from "./clsx.mjs";
import { useTheme as fe } from "@mui/system";
import { PickersYear as de } from "./PickersYear.mjs";
import { useNow as me, useUtils as V, useDefaultDates as pe } from "./useUtils.mjs";
import { getYearCalendarUtilityClass as be } from "./yearCalendarClasses.mjs";
import { applyDefaultDate as E } from "./date-utils.mjs";
import { singleItemValueManager as L } from "./valueManagers.mjs";
import { SECTION_TYPE_GRANULARITY as he } from "./getDefaultReferenceDate.mjs";
import { useControlledValueWithTimezone as ge } from "./useValueWithTimezone.mjs";
import { DIALOG_WIDTH as De, MAX_CALENDAR_HEIGHT as Ye } from "./dimensions.mjs";
import { jsx as M } from "react/jsx-runtime";
import ye from "./styled.mjs";
import Ce from "./useControlled.mjs";
import m from "./useEventCallback.mjs";
import we from "./useForkRef.mjs";
import Fe from "./composeClasses.mjs";
import Pe from "./useThemeProps.mjs";
const Re = ["autoFocus", "className", "value", "defaultValue", "referenceDate", "disabled", "disableFuture", "disablePast", "maxDate", "minDate", "onChange", "readOnly", "shouldDisableYear", "disableHighlightToday", "onYearFocus", "hasFocus", "onFocusedViewChange", "yearsPerRow", "timezone", "gridLabelId"], xe = (p) => {
  const {
    classes: n
  } = p;
  return Fe({
    root: ["root"]
  }, be, n);
};
function ve(p, n) {
  var b;
  const l = V(), i = pe(), u = Pe({
    props: p,
    name: n
  });
  return S({
    disablePast: !1,
    disableFuture: !1
  }, u, {
    yearsPerRow: (b = u.yearsPerRow) != null ? b : 3,
    minDate: E(l, u.minDate, i.minDate),
    maxDate: E(l, u.maxDate, i.maxDate)
  });
}
const Te = ye("div", {
  name: "MuiYearCalendar",
  slot: "Root",
  overridesResolver: (p, n) => n.root
})({
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  overflowY: "auto",
  height: "100%",
  padding: "0 4px",
  width: De,
  maxHeight: Ye,
  // avoid padding increasing width over defined
  boxSizing: "border-box",
  position: "relative"
}), He = /* @__PURE__ */ a.forwardRef(function(n, b) {
  const l = ve(n, "MuiYearCalendar"), {
    autoFocus: i,
    className: u,
    value: B,
    defaultValue: j,
    referenceDate: U,
    disabled: W,
    disableFuture: R,
    disablePast: x,
    maxDate: D,
    minDate: Y,
    onChange: G,
    readOnly: K,
    shouldDisableYear: w,
    disableHighlightToday: v,
    onYearFocus: T,
    hasFocus: q,
    onFocusedViewChange: H,
    yearsPerRow: F,
    timezone: X,
    gridLabelId: $
  } = l, J = ue(l, Re), {
    value: s,
    handleValueChange: Q,
    timezone: A
  } = ge({
    name: "YearCalendar",
    timezone: X,
    value: B,
    defaultValue: j,
    onChange: G,
    valueManager: L
  }), h = me(A), I = fe(), t = V(), y = a.useMemo(
    () => L.getInitialReferenceValue({
      value: s,
      utils: t,
      props: l,
      timezone: A,
      referenceDate: U,
      granularity: he.year
    }),
    []
    // eslint-disable-line react-hooks/exhaustive-deps
  ), N = l, Z = xe(N), O = a.useMemo(() => t.getYear(h), [t, h]), c = a.useMemo(() => s != null ? t.getYear(s) : v ? null : t.getYear(y), [s, t, v, y]), [P, k] = a.useState(() => c || O), [ee, re] = Ce({
    name: "YearCalendar",
    state: "hasFocus",
    controlled: q,
    default: i ?? !1
  }), _ = m((e) => {
    re(e), H && H(e);
  }), z = a.useCallback((e) => {
    if (x && t.isBeforeYear(e, h) || R && t.isAfterYear(e, h) || Y && t.isBeforeYear(e, Y) || D && t.isAfterYear(e, D))
      return !0;
    if (!w)
      return !1;
    const o = t.startOfYear(e);
    return w(o);
  }, [R, x, D, Y, h, w, t]), oe = m((e, o) => {
    if (K)
      return;
    const d = t.setYear(s ?? y, o);
    Q(d);
  }), g = m((e) => {
    z(t.setYear(s ?? y, e)) || (k(e), _(!0), T?.(e));
  });
  a.useEffect(() => {
    k((e) => c !== null && e !== c ? c : e);
  }, [c]);
  const te = m((e, o) => {
    switch (e.key) {
      case "ArrowUp":
        g(o - F), e.preventDefault();
        break;
      case "ArrowDown":
        g(o + F), e.preventDefault();
        break;
      case "ArrowLeft":
        g(o + (I.direction === "ltr" ? -1 : 1)), e.preventDefault();
        break;
      case "ArrowRight":
        g(o + (I.direction === "ltr" ? 1 : -1)), e.preventDefault();
        break;
    }
  }), ae = m((e, o) => {
    g(o);
  }), se = m((e, o) => {
    P === o && _(!1);
  }), f = a.useRef(null), ne = we(b, f);
  return a.useEffect(() => {
    if (i || f.current === null)
      return;
    const e = f.current.querySelector('[tabindex="0"]');
    if (!e)
      return;
    const o = e.offsetHeight, d = e.offsetTop, C = f.current.clientHeight, le = f.current.scrollTop, ie = d + o;
    o > C || d < le || (f.current.scrollTop = ie - C / 2 - o / 2);
  }, [i]), /* @__PURE__ */ M(Te, S({
    ref: ne,
    className: ce(Z.root, u),
    ownerState: N,
    role: "radiogroup",
    "aria-labelledby": $
  }, J, {
    children: t.getYearRange(Y, D).map((e) => {
      const o = t.getYear(e), d = o === c, C = W || z(e);
      return /* @__PURE__ */ M(de, {
        selected: d,
        value: o,
        onClick: oe,
        onKeyDown: te,
        autoFocus: ee && o === P,
        disabled: C,
        tabIndex: o === P ? 0 : -1,
        onFocus: ae,
        onBlur: se,
        "aria-current": O === o ? "date" : void 0,
        yearsPerRow: F,
        children: t.format(e, "year")
      }, t.format(e, "year"));
    })
  }));
});
process.env.NODE_ENV !== "production" && (He.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  autoFocus: r.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * className applied to the root element.
   */
  className: r.string,
  /**
   * The default selected value.
   * Used when the component is not controlled.
   */
  defaultValue: r.any,
  /**
   * If `true` picker is disabled
   */
  disabled: r.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: r.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: r.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: r.bool,
  gridLabelId: r.string,
  hasFocus: r.bool,
  /**
   * Maximal selectable date.
   */
  maxDate: r.any,
  /**
   * Minimal selectable date.
   */
  minDate: r.any,
  /**
   * Callback fired when the value changes.
   * @template TDate
   * @param {TDate} value The new value.
   */
  onChange: r.func,
  onFocusedViewChange: r.func,
  onYearFocus: r.func,
  /**
   * If `true` picker is readonly
   */
  readOnly: r.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid year using the validation props, except callbacks such as `shouldDisableYear`.
   */
  referenceDate: r.any,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: r.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: r.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: r.any,
  /**
   * Years rendered per row.
   * @default 3
   */
  yearsPerRow: r.oneOf([3, 4])
});
export {
  He as YearCalendar
};
//# sourceMappingURL=YearCalendar.mjs.map
